import React, { useEffect } from 'react';
import axios from 'axios';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';


function StripeRedirect() {
    const navigate = useNavigate();
    useEffect(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const success = urlParams.get('success');
      const canceled = urlParams.get('canceled');
      const sessionId = urlParams.get('session_id');
      const body = { isSubscribed: true, _id: localStorage.getItem('_id'), sessionId: sessionId };
      if (success) {
        // Save success information to MongoDB
        
        axios.post('/api/setStripeSubscription', body).then(response => {
          navigate('/dashboard');
        });

      } else if (canceled) {
        // Save cancellation information to MongoDB
        navigate('/settings ');
      }
    }, []);

  return (
    <div>
      <h1>Stripe Redirect</h1>
      <p>Processing redirect...</p>
    </div>
  );
}


export default StripeRedirect;
